import BaseService from '../base';

class Announcement extends BaseService {}

export default new Announcement('announcements', 'Announcement');
